var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report_view_content",on:{"click":_vm.report}},[_c('client-only',[_c('svg-icon',{staticClass:"small-icon",attrs:{"icon-class":"report"}})],1),_vm._v("\n  举报\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }